// ─────────────────────────────────────────────
// partModel.js
// Single source of truth for all parts data.
// Replace MOCK_STOCK_PARTS with: GET /api/parts/
// Replace PARTS_TREE with: GET /api/parts/categories/
// ─────────────────────────────────────────────

// Two-level parts tree: category → subcategories → parts
export const PARTS_TREE = {
  'Motor & Şanzıman': {
    subcategories: {
      'Motor':      ['Motor Komple','Silindir Kapağı','Kam Mili','Krank Mili','Piston','Segman','Yağ Pompası','Su Pompası','Turbo','Intercooler','EGR Valfi','Emme Manifoldu'],
      'Şanzıman':   ['Vites Kutusu','Debriyaj Seti','Debriyaj Balatası','Debriyaj Baskısı','Volan','Şanzıman Yağı','Otomatik Şanzıman'],
      'Alternatör & Marş': ['Alternatör','Marş Motoru','Şarj Rölesi','V Kayışı','Triger Takımı','Triger Kayışı'],
    },
  },
  'Fren Sistemi': {
    subcategories: {
      'Diskler & Balatalar': ['Fren Diski Ön','Fren Diski Arka','Balata Seti Ön','Balata Seti Arka','Trampet'],
      'Hidrolik':            ['Fren Ana Merkezi','Fren Alt Merkezi','Fren Hortumu','Fren Borusu','ABS Pompası'],
      'El Freni & Sensörler':['El Freni Teli','ABS Sensörü','Fren Kaliperi Ön','Fren Kaliperi Arka'],
    },
  },
  'Süspansiyon & Direksiyon': {
    subcategories: {
      'Amortisörler':   ['Amortisör Ön Sol','Amortisör Ön Sağ','Amortisör Arka Sol','Amortisör Arka Sağ','Yay Ön','Yay Arka'],
      'Rotlar & Rotil': ['Rotil','Salıncak','Viraj Rotili','Rot Başı','Rot Kolu','Ön Aks'],
      'Direksiyon':     ['Direksiyon Kutusu','Direksiyon Pompası','Direksiyon Mili','Rot Mili','Direksiyon Körüğü'],
      'Burçlar':        ['Stabilizatör Burcu','Salıncak Burcu','Motor Takozu'],
    },
  },
  'Elektrik & Elektronik': {
    subcategories: {
      'Ateşleme':     ['Buji Seti','Ateşleme Bobini','Distribütör','Krank Sensörü','Kambur Sensörü'],
      'Sensörler':    ['Lambda Sensörü','Hava Debimetri','Gaz Kelebeği Sensörü','Basınç Sensörü','Hız Sensörü'],
      'Kontrol':      ['ECU / Motor Beyni','ABS Beyni','Klima Kumandası','Cam Motoru','Cam Krikosu'],
      'Aydınlatma':   ['Far Sol','Far Sağ','Arka Stop Lambası','Sis Farı Ön','Sis Farı Arka','Sinyal Lambası','Geri Vites Lambası'],
    },
  },
  'Kaporta & Karoser': {
    subcategories: {
      'Ön & Arka':  ['Ön Tampon','Arka Tampon','Ön Izgara','Kaput','Arka Kaporta','Motor Kaputu Menteşesi'],
      'Yan Karoser':['Sağ Ön Çamurluk','Sol Ön Çamurluk','Kapı Ön Sağ','Kapı Ön Sol','Kapı Arka Sağ','Kapı Arka Sol'],
      'Camlar':     ['Ön Cam','Arka Cam','Sol Yan Cam','Sağ Yan Cam','Ayna Sol','Ayna Sağ'],
    },
  },
  'Klima & Soğutma': {
    subcategories: {
      'Klima':   ['Klima Kompresörü','Klima Kondansörü','Klima Filtresi','Polen Filtresi','Klima Borusu'],
      'Soğutma': ['Radyatör','Kalorifer Radyatörü','Termostat','Su Pompası','Genleşme Tankı','Fan Motoru'],
    },
  },
  'Egzoz Sistemi': {
    subcategories: {
      'Egzoz': ['Egzoz Borusu','Egzoz Manifoldu','Katalizör','Susturucu Ön','Susturucu Arka','DPF Filtresi','Oksijen Sensörü'],
    },
  },
  'Yakıt Sistemi': {
    subcategories: {
      'Yakıt': ['Yakıt Pompası','Yakıt Filtresi','Yakıt Deposu','Enjektör','Common Rail','Dizel Filtresi','Karbon Filtresi'],
    },
  },
  'Filtreler & Sarf': {
    subcategories: {
      'Filtreler': ['Yağ Filtresi','Hava Filtresi','Polen Filtresi','Yakıt Filtresi','Şanzıman Filtresi','Hidrolik Filtre'],
      'Sarf':      ['Motor Yağı','Şanzıman Yağı','Antifiriz','Fren Yağı','Direksiyon Yağı'],
    },
  },
  'Akü & Elektrik': {
    subcategories: {
      'Akü': ['Akü 45Ah','Akü 60Ah','Akü 72Ah','Akü 74Ah','Akü 90Ah','Akü 100Ah'],
    },
  },
  'İç Donanım': {
    subcategories: {
      'İç':['Torpido','Koltuk','Paspas','Tavan Döşemesi','Kapı Döşemesi','Güneşlik','Emniyet Kemeri'],
    },
  },
  'Lastik & Jant': {
    subcategories: {
      'Lastik & Jant':['Lastik','Çelik Jant','Alüminyum Jant','Stepne','TPMS Sensörü'],
    },
  },
};

export const PART_CATEGORIES = Object.keys(PARTS_TREE);

// Mock stock — replace with: GET /api/stock/
export const MOCK_STOCK_PARTS = [
  { id:1,  name:'Ön Fren Diski',       oem:'43512-02200', brand:'Brembo', cat:'Fren Sistemi',             subcat:'Diskler & Balatalar', car:'Toyota Corolla',   year:'2018-2023', cond:'Orijinal', price:850,  city:'İstanbul' },
  { id:2,  name:'Amortisör Ön Sağ',    oem:'G16263',      brand:'Monroe', cat:'Süspansiyon & Direksiyon', subcat:'Amortisörler',         car:'Ford Focus',        year:'2015-2020', cond:'Orijinal', price:1200, city:'Ankara'   },
  { id:3,  name:'Alternatör 90A',      oem:'0986049420',  brand:'Bosch',  cat:'Elektrik & Elektronik',    subcat:'Ateşleme',             car:'Renault Megane',    year:'2016-2022', cond:'Orijinal', price:2100, city:'İzmir'    },
  { id:4,  name:'Turbo',               oem:'5Q0145840',   brand:'Gates',  cat:'Motor & Şanzıman',         subcat:'Motor',               car:'VW Golf 7',         year:'2013-2020', cond:'Muadil',   price:3800, city:'Bursa'    },
  { id:5,  name:'Far Sol (LED)',        oem:'63117471221', brand:'Hella',  cat:'Elektrik & Elektronik',    subcat:'Aydınlatma',          car:'BMW 3 Serisi',      year:'2018-2022', cond:'Orijinal', price:4500, city:'Antalya'  },
  { id:6,  name:'Debriyaj Seti',       oem:'3000951802',  brand:'Sachs',  cat:'Motor & Şanzıman',         subcat:'Şanzıman',            car:'Fiat Egea',         year:'2016-2023', cond:'Orijinal', price:1650, city:'Konya'    },
  { id:7,  name:'Radyatör',            oem:'25310D7100',  brand:'Denso',  cat:'Klima & Soğutma',          subcat:'Soğutma',             car:'Hyundai Tucson',    year:'2015-2021', cond:'Orijinal', price:2800, city:'Adana'    },
  { id:8,  name:'Arka Tampon',         oem:'A2058851438', brand:'',       cat:'Kaporta & Karoser',        subcat:'Ön & Arka',           car:'Mercedes C Serisi', year:'2014-2019', cond:'Çıkma',    price:1100, city:'İstanbul' },
  { id:9,  name:'Yağ Pompası',         oem:'8W0115103',   brand:'Febi',   cat:'Motor & Şanzıman',         subcat:'Motor',               car:'Audi A4',           year:'2015-2020', cond:'Orijinal', price:1450, city:'Bursa'    },
  { id:10, name:'Arka Fren Balatası',  oem:'2394202',     brand:'Textar', cat:'Fren Sistemi',             subcat:'Diskler & Balatalar', car:'Honda Civic',       year:'2017-2022', cond:'Orijinal', price:620,  city:'İstanbul' },
  { id:11, name:'Klima Kompresörü',    oem:'TSP0155883',  brand:'Delphi', cat:'Klima & Soğutma',          subcat:'Klima',               car:'Opel Astra',        year:'2016-2022', cond:'Orijinal', price:3200, city:'Ankara'   },
  { id:12, name:'Egzoz Manifoldu',     oem:'1719J5',      brand:'Bosal',  cat:'Egzoz Sistemi',            subcat:'Egzoz',               car:'Peugeot 308',       year:'2013-2018', cond:'Muadil',   price:950,  city:'İzmir'    },
  { id:13, name:'Rotil',               oem:'JBJ726',      brand:'TRW',    cat:'Süspansiyon & Direksiyon', subcat:'Rotlar & Rotil',      car:'Ford Focus',        year:'2012-2019', cond:'Orijinal', price:480,  city:'İstanbul' },
  { id:14, name:'Triger Takımı',       oem:'CT1028K1',    brand:'Gates',  cat:'Motor & Şanzıman',         subcat:'Alternatör & Marş',   car:'Volkswagen Golf',   year:'2010-2020', cond:'Orijinal', price:2200, city:'Ankara'   },
  { id:15, name:'Balata Seti Ön',      oem:'GDB1553',     brand:'TRW',    cat:'Fren Sistemi',             subcat:'Diskler & Balatalar', car:'Toyota Corolla',    year:'2015-2023', cond:'Muadil',   price:420,  city:'İzmir'    },
];